import { Injectable } from '@angular/core';
import { Message } from 'primeng/api';

@Injectable()
export class NotificationService {
    notifications: Message[] = [];
 
  growlNotification(type: string, message: string) {
        this.notifications = [];
        switch (type) {
            case 'succ':
                this.notifications.push({ severity: 'success', summary: 'Success Message', detail: message });
                break;
            case 'fail':
                this.notifications.push({ severity: 'error', summary: 'Error Message', detail: message });
                break;
            default:
                this.notifications.push({ severity: 'warn', summary: 'Warn Message', detail: message });
                break;
        }
        return this.notifications;
    }
}



// WEBPACK FOOTER //
// ./src/opc/shared/services/notification.service.ts